import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FiEye, FiEdit2, FiTrash2 } from "react-icons/fi";
import CrearOrganizacion from "./CrearOrganizacion";
import NoOrganizaciones from "./NoOrganizaciones";
import { useNavigate } from 'react-router-dom';
import CustomCircularProgress from "../../Components/Loading/CustomCircularProgress";
import { getAllOrganizaciones } from "../../endpoints";

const Organizaciones = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [openForm, setOpenForm] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [organizations, setOrganizations] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const itemsPerPage = 30; // Número de organizaciones por página

  const getOrganizaciones = (page = 1, searchTerm = "") => {
    setLoading(true);
    getAllOrganizaciones({
      page,
      perPage: itemsPerPage,
      filterBy: searchTerm
    })
      .then((response) => {
        const { total, organizaciones } = response.data;
        setOrganizations(organizaciones);
        setTotalPages(Math.ceil(total / itemsPerPage));
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error al obtener organizaciones:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    getOrganizaciones(currentPage, searchTerm);
  }, [currentPage, searchTerm]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reiniciar a la primera página en caso de una nueva búsqueda
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <Container>
      {openForm ? (
        <CrearOrganizacion setOpenForm={setOpenForm} />
      ) : (
        <>
          <FlexRow>
            <SearchBar
              placeholder="Buscar"
              value={searchTerm}
              onChange={handleSearch}
            />
            <CreateOrg
              onClick={() => navigate("/organizaciones/create-organizacion")}
            >
              Agregar
            </CreateOrg>
          </FlexRow>

          {loading ? (

            <CustomCircularProgress size={"40"} styled={{ margin: "auto" }} />


          ) : (
            <OrganizationList>
              {organizations?.length < 1 ? (
                <NoOrganizaciones />
              ) : (
                organizations?.map((org) => (
                  <OrganizationItem key={org.id}>
                    <OrgInfo>
                      <OrgLogo src={org.logo} alt="Logo" />
                      <div>
                        <OrgName>{org.name}</OrgName>
                        <OrgDetails>{org.sector_rubro} | {org.localidad}</OrgDetails>
                      </div>
                    </OrgInfo>
                    <ActionIcons>
                      <FiEye onClick={() => navigate(`/organizaciones/${org.id}`)} />
                      <FiEdit2 onClick={() => navigate(`/organizaciones/editar/${org.id}`)} />
                      <FiTrash2 />
                    </ActionIcons>
                  </OrganizationItem>
                ))
              )}
            </OrganizationList>
          )}

          {/* Paginación */}
          <PaginationContainer>
            <PaginationButton
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Anterior
            </PaginationButton>
            <PageNumber> Página {currentPage} de {totalPages > 0 ? totalPages : 1} </PageNumber>
            <PaginationButton
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Siguiente
            </PaginationButton>
          </PaginationContainer>
        </>
      )}
    </Container>
  );
};

export default Organizaciones;

// Styled components
const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

const Container = styled.div`
  background-color: #ffffff;
  width: auto;
  min-width: -webkit-fill-available;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 16px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  box-sizing: border-box;
  margin: 1%;
  min-height: 86vh;
  justify-content: space-between;
`;

const SearchBar = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  color: #333;
  box-sizing: border-box;
  &::placeholder {
    color: #999;
  }
`;

const OrganizationList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  overflow-y: auto;
  max-height: 70vh;
  min-height: 70vh;
  padding: 8px 0px;
`;

const OrganizationItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: ${(props) => (props.isActive ? "#e0e0e0" : "#ffffff")};
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s;
  margin-right: 8px;
  &:hover {
    background-color: #f9f9f9;
  }
`;

const OrgInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const OrgLogo = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
`;

const OrgName = styled.h3`
  font-family: 'Montserrat', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0px;
`;

const OrgDetails = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #777;
  margin: 0px;
`;

const ActionIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  color: #333;
  font-size: 18px;
  svg {
    cursor: pointer;
    transition: color 0.3s;
    &:hover {
      color: #ff6b6b;
    }
  }
`;

const CreateOrg = styled.button`
  padding: 12px 24px;
  background-color: #003049;
  border: none;
  border-radius: 8px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.3s;
  &:hover {
    background-color: #002538;
  }
`;

// Paginación
const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
`;

const PaginationButton = styled.button`
  padding: 8px 16px;
  background-color: #003049;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const PageNumber = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #333;
`;
